import { useState } from "react";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

export default function Step4PostalCode({ value, onNext, onBack }) {
  const [postalCode, setPostalCode] = useState(value || "");
  const [error, setError] = useState("");

  const handleContinue = () => {
    if (!postalCode || postalCode.length !== 5) {
      setError("Bitte gebe eine gültige 5-stellige Postleitzahl ein.");
      return;
    }
    onNext({ postalCode });
  };

  const handleChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "").slice(0, 5);
    setPostalCode(value);
    setError("");
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Wo findet dein Event statt?"
        description="Mit deiner Postleitzahl zeigen wir dir verfügbare Anbieter in deiner Region."
      />

      <div className="space-y-3">
        <label className="block">
          <span className="text-sm font-medium text-slate-700 mb-2 block">
            Postleitzahl
          </span>
          <input
            type="text"
            inputMode="numeric"
            value={postalCode}
            onChange={handleChange}
            placeholder="z.B. 48143"
            maxLength={5}
            className={`w-full rounded-lg border-2 px-4 py-3 text-lg font-semibold tracking-widest transition ${
              error
                ? "border-red-300 bg-red-50"
                : "border-slate-200 bg-white focus:border-[#FF5744] focus:outline-none"
            }`}
          />
        </label>
        {error && <p className="text-sm text-red-600 font-medium">{error}</p>}
      </div>

      {/* Navigation */}
      <WizardNavigation
        onBack={onBack}
        onNext={handleContinue}
        disableNext={!postalCode || postalCode.length !== 5}
      />
    </div>
  );
}
